(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[15],{

/***/ "7afx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChildcareContext; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
 // $FlowFixMe

var ChildcareContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createContext({});

/***/ }),

/***/ "AinJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getSpecificChildcareLabel; });
/* unused harmony export mapOpeningHours */
/* unused harmony export dayIds */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mapClosingDays; });
/* unused harmony export getClosingDays */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return rentedTotalPriceByChild; });
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash_capitalize__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("h++M");
/* harmony import */ var lodash_capitalize__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_capitalize__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _reservation_block_PopInReservationBlockMorningAfternoonExclusive__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("fYIP");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("ldK3");









var getSpecificChildcareLabel = function getSpecificChildcareLabel(currentChildInfo) {
  var _rentedSchedules$, _rentedSchedules$2;

  var hasManySchedules = (currentChildInfo === null || currentChildInfo === void 0 ? void 0 : currentChildInfo.schedules.length) > 1;
  var rentedSchedules = currentChildInfo === null || currentChildInfo === void 0 ? void 0 : currentChildInfo.schedules.filter(function (_ref) {
    var isPartiallyRented = _ref.isPartiallyRented;
    return isPartiallyRented;
  });
  var rentedSchedulesNumber = rentedSchedules === null || rentedSchedules === void 0 ? void 0 : rentedSchedules.length;
  var scheduleHasDifferentStartEndDates = ((_rentedSchedules$ = rentedSchedules[0]) === null || _rentedSchedules$ === void 0 ? void 0 : _rentedSchedules$.startDate) !== ((_rentedSchedules$2 = rentedSchedules[0]) === null || _rentedSchedules$2 === void 0 ? void 0 : _rentedSchedules$2.endDate);
  var hasRentedFullStaySchedule = rentedSchedulesNumber === 1 && scheduleHasDifferentStartEndDates;
  var hasRentedAtLeastOneSingleDaySchedule = rentedSchedules.length > 1 || rentedSchedulesNumber === 1 && rentedSchedules[0].startDate === rentedSchedules[0].endDate;

  if (hasManySchedules && hasRentedAtLeastOneSingleDaySchedule) {
    // here is the case of one or many days from the stay
    // we display { n } days
    return Object(_i18n__WEBPACK_IMPORTED_MODULE_7__[/* t */ "h"])('common.dateTime.day', {
      count: rentedSchedulesNumber
    });
  }

  if (hasRentedFullStaySchedule) {
    var _rentedSchedules$3, _rentedSchedules$3$ti; // here is the case of renting the full stay slot but in the case of childcare by day
    // or the case of renting the full stay slot but in the case of the simple childcare
    // here is the case of slots


    var selectedSlots = rentedSchedules === null || rentedSchedules === void 0 ? void 0 : (_rentedSchedules$3 = rentedSchedules[0]) === null || _rentedSchedules$3 === void 0 ? void 0 : (_rentedSchedules$3$ti = _rentedSchedules$3.timeSlots) === null || _rentedSchedules$3$ti === void 0 ? void 0 : _rentedSchedules$3$ti.filter(function (_ref2) {
      var isRented = _ref2.isRented;
      return isRented;
    }); // for now we only select one slot for the exclusivity of morning or afternoon or all day

    var slotName = selectedSlots === null || selectedSlots === void 0 ? void 0 : selectedSlots[0].slotName;
    return hasManySchedules ? Object(_i18n__WEBPACK_IMPORTED_MODULE_7__[/* t */ "h"])('booking.activities.childcare.allStay') : Object(_reservation_block_PopInReservationBlockMorningAfternoonExclusive__WEBPACK_IMPORTED_MODULE_5__[/* getSlotLabel */ "b"])(slotName);
  }

  return '';
};
var mapOpeningHours = function mapOpeningHours(_ref3) {
  var start = _ref3.start,
      end = _ref3.end;
  var formattedStart = Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_8__[/* formatApiTime */ "h"])(start, 'LT').toLowerCase();
  var formattedEnd = Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_8__[/* formatApiTime */ "h"])(end, 'LT').toLowerCase();
  return Object(_i18n__WEBPACK_IMPORTED_MODULE_7__[/* t */ "h"])('booking.services.childcare.openingHours', {
    ' opening_hours - start ': formattedStart,
    ' opening_hours - end ': formattedEnd
  });
};
var dayIds = {
  SU: 0,
  MO: 1,
  TU: 2,
  WE: 3,
  TH: 4,
  FR: 5,
  SA: 6
};
var mapClosingDays = function mapClosingDays(closingAbbr) {
  var index = dayIds[closingAbbr.toUpperCase()];

  if (index === undefined) {
    return '';
  }

  var dayName = moment__WEBPACK_IMPORTED_MODULE_6___default()().day(index).format('dddd');
  return lodash_capitalize__WEBPACK_IMPORTED_MODULE_4___default()(dayName);
};
var getClosingDays = function getClosingDays(closingWeekdays) {
  if (!(closingWeekdays === null || closingWeekdays === void 0 ? void 0 : closingWeekdays.length)) {
    return '';
  }

  return Object(_i18n__WEBPACK_IMPORTED_MODULE_7__[/* t */ "h"])('booking.services.childcare.closingDays', {
    closing_weekdays: closingWeekdays.map(mapClosingDays).join(', ')
  });
};
var rentedTotalPriceByChild = function rentedTotalPriceByChild(childcare, currentChildRentedAmout) {
  // May be confusing to have startingPricePerAdult for a child but the property is shared between all upsells
  // and now the childcare behaves in a classic upsell way
  var childcareStartingPrice = childcare.pricingInfo.startingPricePerAdult.value;
  var isChildcareUpsell = childcareStartingPrice > 0;

  if (isChildcareUpsell) {
    var _childcare$pricingInf, _childcare$pricingInf2;

    var hasRentedFromThisChildcare = ((_childcare$pricingInf = childcare.pricingInfo.attendees) === null || _childcare$pricingInf === void 0 ? void 0 : (_childcare$pricingInf2 = _childcare$pricingInf.find(function (_ref4) {
      var id = _ref4.id;
      return id === childcare.pricingInfo.childId;
    })) === null || _childcare$pricingInf2 === void 0 ? void 0 : _childcare$pricingInf2.rentedAmount.value) > 0;

    if (hasRentedFromThisChildcare) {
      var rentedPrice = "".concat(currentChildRentedAmout.formattedValue);
      return rentedPrice;
    }

    return childcare.pricingInfo.startingPricePerAdult.fornattedValue;
  } // included


  return Object(_i18n__WEBPACK_IMPORTED_MODULE_7__[/* t */ "h"])('booking.common.included');
};

/***/ }),

/***/ "C9cF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IS_DISABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IS_ENABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IS_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createPropsForProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getRentalAgesLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getServiceAgesLabel; });
/* unused harmony export getServiceAgesLabelTranslateOptions */
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("kiXb");



var IS_DISABLED = 'isDisabled';
var IS_ENABLED = 'isEnabled';
var IS_SELECTED = 'isSelected';

var getServiceAgesLabel = function getServiceAgesLabel(ageInMonths) {
  var min = ageInMonths.min,
      max = ageInMonths.max;

  if (min > 23) {
    return Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "h"])('booking.services.childcare.kidsAgeInYears', {
      min: Math.floor(min / 12),
      max: max ? Math.floor(max / 12) : ''
    });
  }

  if (min < 23 && max && max > 23) {
    return Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "h"])('booking.services.childcare.kidsAgeInMonthsAndYears', {
      min: min,
      max: Math.floor(max / 12)
    });
  }

  return Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "h"])('booking.services.childcare.kidsAgeInMonths', {
    min: min,
    // $FlowFixMe 🤬
    max: max
  });
};

function getServiceAgesLabelTranslateOptions(ageInMonths) {
  var min = ageInMonths.min,
      max = ageInMonths.max;

  if (min > 23) {
    return ['booking.services.childcare.kidsAgeInYears', {
      min: Math.floor(min / 12),
      max: max ? Math.floor(max / 12) : ''
    }];
  }

  if (min < 23 && max && max > 23) {
    return ['booking.services.childcare.kidsAgeInMonthsAndYears', {
      min: min,
      max: Math.floor(max / 12)
    }];
  }

  return ['booking.services.childcare.kidsAgeInMonths', {
    min: min,
    // $FlowFixMe 🤬
    max: max
  }];
}

var getRentalAgesLabel = function getRentalAgesLabel(ageInMonths) {
  if (!ageInMonths || !ageInMonths.min) {
    return Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "h"])('booking.activities.forAllAges');
  }

  if (ageInMonths.max) {
    return getServiceAgesLabel(ageInMonths);
  }

  if (ageInMonths.min < 23) {
    return Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "h"])('booking.activities.ageFromMonths', {
      amount: ageInMonths.min
    });
  }

  return Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "h"])('booking.activities.ageFrom', {
    age: Math.floor(ageInMonths.min / 12)
  });
};

var createPropsForPictures = function createPropsForPictures(images) {
  if (!Array.isArray(images)) {
    return [];
  }

  return images.map(function (link) {
    return {
      src: link
    };
  });
};

var createPropsForProduct = function createPropsForProduct(resort) {
  var _resort$destination;

  return {
    id: resort.id,
    header: {
      className: 'border-r-1',
      heading: {
        subtitle: resort === null || resort === void 0 ? void 0 : (_resort$destination = resort.destination) === null || _resort$destination === void 0 ? void 0 : _resort$destination.country,
        title: resort.name || ''
      },
      link: {
        url: resort.href
      },
      productId: resort.id,
      productType: resort.type
    },
    thumbnail: {
      link: {
        url: resort.href
      },
      pictures: createPropsForPictures(resort.images),
      productId: resort.id,
      productType: resort.type
    },
    url: resort.href,
    type: resort.type || ''
  };
};



/***/ }),

/***/ "eMTQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RadioGroup; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_kebabCase__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("s2Gj");
/* harmony import */ var lodash_kebabCase__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_kebabCase__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("C/y5");
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("ljKo");
/* harmony import */ var _inputsUtils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("vpua");
/* harmony import */ var _formik_input_Radio__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("yWv5");
/* harmony import */ var _formik_input_ErrorNote__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("TuHz");





var __jsx = react__WEBPACK_IMPORTED_MODULE_5___default.a.createElement;






var RadioGroup = function RadioGroup(_ref) {
  var className = _ref.className,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$isRequired = _ref.isRequired,
      isRequired = _ref$isRequired === void 0 ? false : _ref$isRequired,
      name = _ref.name,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      validate = _ref.validate,
      hideErrorMessage = _ref.hideErrorMessage,
      _ref$radioHasBorder = _ref.radioHasBorder,
      radioHasBorder = _ref$radioHasBorder === void 0 ? true : _ref$radioHasBorder,
      _ref$itemsCentered = _ref.itemsCentered,
      itemsCentered = _ref$itemsCentered === void 0 ? true : _ref$itemsCentered;
  var formik = Object(formik__WEBPACK_IMPORTED_MODULE_7__[/* useFormikContext */ "e"])();
  return __jsx("div", {
    className: "sm:w-full",
    "data-testid": "RadioGroup"
  }, __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_6__[/* classnames */ "a"])('-mx-5 flex', className)
  }, options.map(function (_ref2) {
    var label = _ref2.label,
        value = _ref2.value,
        _ref2$isDisabledRadio = _ref2.isDisabledRadio,
        isDisabledRadio = _ref2$isDisabledRadio === void 0 ? false : _ref2$isDisabledRadio;
    var fieldIdentifier = "".concat(name, "-").concat(value);
    return __jsx(formik__WEBPACK_IMPORTED_MODULE_7__[/* Field */ "b"], {
      key: fieldIdentifier,
      name: name,
      type: "radio",
      validate: validate ? Object(_inputsUtils__WEBPACK_IMPORTED_MODULE_8__[/* getValidateFieldFunction */ "c"])(validate) : undefined,
      value: value
    }, function (_ref3) {
      var field = _ref3.field,
          form = _ref3.form;

      var _getValidationStatus = Object(_inputsUtils__WEBPACK_IMPORTED_MODULE_8__[/* getValidationStatus */ "d"])(field, form, false),
          isDefaultState = _getValidationStatus.isDefaultState,
          isErrored = _getValidationStatus.isErrored,
          isValidated = _getValidationStatus.isValidated;

      var classes = Object(_inputsUtils__WEBPACK_IMPORTED_MODULE_8__[/* getInputClasses */ "b"])({
        hasHeight: true,
        isDefaultState: isDefaultState,
        isDisabled: isDisabled,
        isErrored: isErrored,
        isValidated: isValidated && field.checked,
        hasNoBorder: !radioHasBorder
      });
      return __jsx(_formik_input_Radio__WEBPACK_IMPORTED_MODULE_9__[/* Radio */ "a"], {
        className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_6__[/* classnames */ "a"])('mx-5 flex-1 font-bold', classes),
        field: field,
        form: form,
        isDisabled: isDisabled || isDisabledRadio,
        isRequired: isRequired,
        label: label,
        size: "size-20",
        itemsCentered: itemsCentered
      });
    });
  })), __jsx("div", {
    className: "px-10"
  }, !hideErrorMessage && formik.submitCount > 0 && __jsx(_formik_input_ErrorNote__WEBPACK_IMPORTED_MODULE_10__[/* ErrorNote */ "a"], {
    isErrored: formik.submitCount > 0,
    errorMessage: lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(formik.errors, name),
    errorNoteId: "error-".concat(lodash_kebabCase__WEBPACK_IMPORTED_MODULE_3___default()(name))
  })));
};

/***/ }),

/***/ "erJz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isBabyClubMed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isPetitClubMed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isBabyOrPetitCM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DurationSlotsLabels; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return displayChildcaresNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addOrRemoveChildcareFromCart; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("vfdX");
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("5BYb");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("Ee2X");
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _date_apiDate__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("ldK3");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("kiXb");
/* harmony import */ var _client_components_widgets_childcare_summary_ChildcareSummary_utils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("AinJ");
/* harmony import */ var _childcare_consts__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("gzwZ");









var __jsx = react__WEBPACK_IMPORTED_MODULE_9___default.a.createElement;





var isBabyClubMed = function isBabyClubMed(childcare) {
  var childcareMinAge = childcare.productInfo.ageInMonths.min;
  return childcareMinAge === _childcare_consts__WEBPACK_IMPORTED_MODULE_13__[/* BABY_CM_CHILDCARE_MIN_AGE */ "a"];
};
var isPetitClubMed = function isPetitClubMed(childcare) {
  var childcareMinAge = childcare.productInfo.ageInMonths.min;
  return childcareMinAge === _childcare_consts__WEBPACK_IMPORTED_MODULE_13__[/* PETIT_CM_CHILDCARE_MIN_AGE */ "c"];
};
var isBabyOrPetitCM = function isBabyOrPetitCM(childcare) {
  return isBabyClubMed(childcare) || isPetitClubMed(childcare);
};

var getClosingDays = function getClosingDays(closingWeekdays) {
  if (!(closingWeekdays === null || closingWeekdays === void 0 ? void 0 : closingWeekdays.length)) {
    return '';
  } // eslint-disable-next-line camelcase


  var closing_weekdays = closingWeekdays.map(_client_components_widgets_childcare_summary_ChildcareSummary_utils__WEBPACK_IMPORTED_MODULE_12__[/* mapClosingDays */ "b"]).join(', ');
  return Object(_i18n__WEBPACK_IMPORTED_MODULE_11__[/* t */ "h"])('booking.services.childcare.closingDays', {
    closing_weekdays: closing_weekdays
  });
};

var DurationSlotsLabels = function DurationSlotsLabels(_ref) {
  var timeSlots = _ref.timeSlots,
      closingWeekdays = _ref.closingWeekdays,
      _ref$rentedOrPaidTime = _ref.rentedOrPaidTimeSlots,
      rentedOrPaidTimeSlots = _ref$rentedOrPaidTime === void 0 ? [] : _ref$rentedOrPaidTime,
      _ref$showOnlyRentedOr = _ref.showOnlyRentedOrPaid,
      showOnlyRentedOrPaid = _ref$showOnlyRentedOr === void 0 ? false : _ref$showOnlyRentedOr,
      _ref$classNames = _ref.classNames,
      classNames = _ref$classNames === void 0 ? '' : _ref$classNames,
      isPetitCM = _ref.isPetitCM;
  var keySlots = {
    MORNING: 'booking.services.childcare.timeslotMorning',
    AFTERNOON: 'booking.services.childcare.timeslotAfternoon',
    DAY: 'booking.services.childcare.timeslotAllDay',
    EVENING: isPetitCM ? 'booking.services.childcare.timeslotEvening' : 'booking.services.childcare.timeslotEvening2'
  };
  var closedDaysLabel = getClosingDays(closingWeekdays);

  if ((timeSlots === null || timeSlots === void 0 ? void 0 : timeSlots.length) === 0) {
    return closedDaysLabel || '';
  }

  return __jsx("p", {
    className: classNames
  }, timeSlots.map(function (timeSlot) {
    return (rentedOrPaidTimeSlots === null || rentedOrPaidTimeSlots === void 0 ? void 0 : rentedOrPaidTimeSlots.some(function (_ref2) {
      var slotName = _ref2.slotName;
      return slotName === timeSlot.type;
    })) || !showOnlyRentedOrPaid ? __jsx(react__WEBPACK_IMPORTED_MODULE_9__["Fragment"], {
      key: "".concat(timeSlot.type, "-").concat(timeSlot.opening)
    }, __jsx("span", null, Object(_i18n__WEBPACK_IMPORTED_MODULE_11__[/* t */ "h"])(keySlots[timeSlot.type], {
      opening: Object(_date_apiDate__WEBPACK_IMPORTED_MODULE_10__[/* formatApiTime */ "h"])(timeSlot.opening, 'LT').toLowerCase(),
      closing: Object(_date_apiDate__WEBPACK_IMPORTED_MODULE_10__[/* formatApiTime */ "h"])(timeSlot.closing, 'LT').toLowerCase()
    })), __jsx("br", null)) : null;
  }), closedDaysLabel && __jsx("span", null, closedDaysLabel));
};
var displayChildcaresNames = function displayChildcaresNames(selectedProposal, childcares) {
  var childcaresAttendees = childcares.filter(function (childcare) {
    var _currentAttendee$rent;

    var currentAttendee = childcare.pricingInfo.attendees.find(function (_ref3) {
      var id = _ref3.id;
      return id === childcare.pricingInfo.childId;
    });
    var currentAttendeeHasRentedOrIncluded = (currentAttendee === null || currentAttendee === void 0 ? void 0 : (_currentAttendee$rent = currentAttendee.rentedAmount) === null || _currentAttendee$rent === void 0 ? void 0 : _currentAttendee$rent.value) && currentAttendee.rentedAmount.value > 0 || childcare.productInfo.isIncluded;
    return currentAttendeeHasRentedOrIncluded;
  });
  var finalLabel = childcaresAttendees.reduce(function (composedLabel, newChildcare, index) {
    return composedLabel + "".concat(index > 0 ? ' | ' : '', " 1 ").concat(newChildcare.productInfo.label);
  }, '');
  return finalLabel;
};
function addOrRemoveChildcareFromCart(_ref4) {
  var childcareCart = _ref4.childcareCart,
      attendeeId = _ref4.attendeeId,
      childcareId = _ref4.childcareId,
      startDate = _ref4.startDate,
      endDate = _ref4.endDate,
      bookingId = _ref4.bookingId,
      updateCart = _ref4.updateCart,
      appContext = _ref4.appContext;
  var attendees = (childcareCart && childcareCart.attendees || []).map(function (_ref5) {
    var id = _ref5.id;
    return {
      id: id
    };
  });
  var index = attendees.findIndex(function (_ref6) {
    var id = _ref6.id;
    return id === attendeeId;
  });

  if (index !== -1 && attendees.length === 1) {
    return updateCart({
      id: childcareId,
      bookingId: bookingId,
      context: appContext,
      action: 'remove',
      serviceName: 'CHILDCARE'
    });
  }

  if (index !== -1) {
    attendees.splice(index, 1);
  } else {
    attendees.push({
      id: attendeeId
    });
  }

  var schedules = [{
    start_date: startDate,
    end_date: endDate,
    attendees: attendees
  }];
  return updateCart({
    id: childcareId,
    bookingId: bookingId,
    schedules: schedules,
    context: appContext,
    action: 'update',
    serviceName: 'CHILDCARE'
  });
}

/***/ }),

/***/ "fYIP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getSlotLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PopInReservationBlockMorningAfternoonExclusive; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("vrRf");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("lTEL");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("tQbP");
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("JtPf");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_promise_finally__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("Qavd");
/* harmony import */ var core_js_modules_es_promise_finally__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_finally__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("kYxP");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("3yYM");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("QsI/");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("kiXb");
/* harmony import */ var _frameworks_modal_Modal__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("EvYw");
/* harmony import */ var _frameworks_formik_RadioGroup__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("eMTQ");
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__("ljKo");
/* harmony import */ var _reservationBlock_utils__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__("2hfc");
/* harmony import */ var _frameworks_button_Button__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__("e0Ti");
/* harmony import */ var _context_ChildcareContext__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__("7afx");






















var __jsx = react__WEBPACK_IMPORTED_MODULE_23___default.a.createElement;


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_20__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










/**
 This PopInReservationBlockMorningAfternoonExclusive covers one specific case of a childcare that is only available to book :
  - the morning
  - or in the afternoon
  - or all day
 in an exclusive way (only ONE) and for the WHOLE Stay
 *
 */
var getSlotLabel = function getSlotLabel(slotType) {
  switch (slotType) {
    case _reservationBlock_utils__WEBPACK_IMPORTED_MODULE_28__[/* MORNING */ "f"]:
      return Object(_i18n__WEBPACK_IMPORTED_MODULE_24__[/* t */ "h"])('booking.activities.timeSlot.morningTitle');

    case _reservationBlock_utils__WEBPACK_IMPORTED_MODULE_28__[/* AFTERNOON */ "a"]:
      return Object(_i18n__WEBPACK_IMPORTED_MODULE_24__[/* t */ "h"])('booking.activities.timeSlot.afternoonTitle');

    case 'DAY':
      return Object(_i18n__WEBPACK_IMPORTED_MODULE_24__[/* t */ "h"])('booking.activities.timeSlot.allDayTitle');

    default:
      return Object(_i18n__WEBPACK_IMPORTED_MODULE_24__[/* t */ "h"])('booking.activities.timeSlot.allDayTitle');
  }
};
var PopInReservationBlockMorningAfternoonExclusive = function PopInReservationBlockMorningAfternoonExclusive(_ref) {
  var _currentChildPricingI, _currentChildSchedule, _orderedSlots$find;

  var slots = _ref.slots,
      onClose = _ref.onClose,
      headerLabel = _ref.headerLabel,
      service = _ref.service;

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_23__["useState"])(false),
      isLoading = _useState[0],
      setIsLoading = _useState[1];

  var _useContext = Object(react__WEBPACK_IMPORTED_MODULE_23__["useContext"])(_context_ChildcareContext__WEBPACK_IMPORTED_MODULE_30__[/* ChildcareContext */ "a"]),
      addAttendeeChildcare = _useContext.addAttendeeChildcare;

  var pricingInfoAttendees = service.attendees;
  var currentChildPricingInfo = pricingInfoAttendees.find(function (attendee) {
    return attendee.id === service.childId;
  }); // as we only have one schedule we take the first one

  var currentChildSchedule = currentChildPricingInfo === null || currentChildPricingInfo === void 0 ? void 0 : (_currentChildPricingI = currentChildPricingInfo.schedules) === null || _currentChildPricingI === void 0 ? void 0 : _currentChildPricingI[0];
  var initiallySelectedSlot = currentChildSchedule === null || currentChildSchedule === void 0 ? void 0 : (_currentChildSchedule = currentChildSchedule.timeSlots) === null || _currentChildSchedule === void 0 ? void 0 : _currentChildSchedule.find(function (_ref2) {
    var isRented = _ref2.isRented,
        isPaid = _ref2.isPaid;
    return !!isRented || !!isPaid;
  }); // slots display order left to right
  // MORNING', 'AFTERNOON', 'DAY'

  var SLOTS_ORDER = ['MORNING', 'AFTERNOON', 'DAY']; // because it s read only array

  var slotsCopy = Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_21__[/* default */ "a"])(slots);

  var orderedSlots = slotsCopy.map(function (slot) {
    // ¯\_(ツ)_/¯
    // fix for the CC.we lose the timeslot once a slot is paid, cuz it disappears from the additionalServices route
    // and the time slot is not sent by the booking/services
    if (service.isPartiallyPaid && slot.remainingStock === null && slot.initialStock === null && slot.type === 'DAY') {
      var _SLOTS_ORDER$filter;

      var slotsTypes = slots.map(function (_ref3) {
        var type = _ref3.type;
        return type;
      }); // find the missing slot type ( transformed to DAY by error  )

      var missingSlot = ((_SLOTS_ORDER$filter = SLOTS_ORDER.filter(function (s) {
        return !slotsTypes.includes(s);
      })) === null || _SLOTS_ORDER$filter === void 0 ? void 0 : _SLOTS_ORDER$filter[0]) || 'DAY'; // this is the paid slot we need to fix it's slot type

      return _objectSpread(_objectSpread({}, slot), {}, {
        type: missingSlot
      });
    }

    return slot;
  }).sort(function (a, b) {
    return SLOTS_ORDER.indexOf(a.type) - SLOTS_ORDER.indexOf(b.type);
  });

  var handleSubmit = /*#__PURE__*/function () {
    var _ref4 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_19__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_22___default.a.mark(function _callee(values) {
      var selectedSlotProduct;
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_22___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsLoading(true);
              selectedSlotProduct = slots.find(function (slot) {
                return slot.id === values.selectedSlotProductId;
              });

              if (!(values.selectedSlotProductId === (initiallySelectedSlot === null || initiallySelectedSlot === void 0 ? void 0 : initiallySelectedSlot.id) || !selectedSlotProduct)) {
                _context.next = 5;
                break;
              }

              setIsLoading(false);
              return _context.abrupt("return");

            case 5:
              addAttendeeChildcare({
                attendeeId: service.childId || '',
                pricingInfo: service,
                serviceId: selectedSlotProduct.id
              }).finally(function () {
                setIsLoading(false);
                onClose();
              });

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleSubmit(_x) {
      return _ref4.apply(this, arguments);
    };
  }();

  return __jsx(_frameworks_modal_Modal__WEBPACK_IMPORTED_MODULE_25__[/* Modal */ "a"], {
    ariaLabel: headerLabel,
    closeLabel: Object(_i18n__WEBPACK_IMPORTED_MODULE_24__[/* t */ "h"])('common.close'),
    onClose: onClose,
    size: "medium",
    className: ""
  }, __jsx("div", {
    className: "align-center flex flex-col justify-center p-30"
  }, __jsx("h3", {
    className: "mt-10 text-center font-brand text-24 font-bold leading-1 text-black"
  }, headerLabel), __jsx("div", {
    className: "flex flex-col justify-center p-40 pb-0"
  }, __jsx("p", {
    className: "py-20 text-14 font-bold"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_24__[/* t */ "h"])('booking.activities.childcare.chooseFullStayTimeSlot')), __jsx(formik__WEBPACK_IMPORTED_MODULE_27__[/* Formik */ "d"], {
    initialValues: {
      selectedSlotProductId: ((_orderedSlots$find = orderedSlots.find(function (slot) {
        return slot.id === (initiallySelectedSlot === null || initiallySelectedSlot === void 0 ? void 0 : initiallySelectedSlot.id);
      })) === null || _orderedSlots$find === void 0 ? void 0 : _orderedSlots$find.id) || ''
    }
  }, function (formik) {
    var _orderedSlots$find2, _orderedSlots$find2$a, _orderedSlots$find2$a2;

    return __jsx("form", null, __jsx(_frameworks_formik_RadioGroup__WEBPACK_IMPORTED_MODULE_26__[/* RadioGroup */ "a"], {
      className: "mb-10 flex-col md:flex-row",
      name: "selectedSlotProductId",
      options: orderedSlots === null || orderedSlots === void 0 ? void 0 : orderedSlots.map(function (slot) {
        var _service$attendees$fi, _service$attendees$fi2, _service$attendees$fi3;

        return {
          value: slot.id,
          label: __jsx("div", {
            className: "flex flex-col"
          }, __jsx("span", {
            className: "text-14 font-bold"
          }, getSlotLabel(slot.type)), __jsx("span", {
            className: "text-12 font-bold text-sienna"
          }, "+ ", slot.attendees[0].price.formattedValue), slot.remainingStock === 0 && __jsx("span", {
            className: "text-12 font-bold text-sienna"
          }, Object(_i18n__WEBPACK_IMPORTED_MODULE_24__[/* t */ "h"])('booking.services.childcare.childcareFull')), slot.remainingStock > 0 && slot.remainingStock <= 10 && __jsx("span", {
            className: "text-12 font-bold text-sienna"
          }, Object(_i18n__WEBPACK_IMPORTED_MODULE_24__[/* t */ "h"])('booking.services.childcare.childcareAvailabilities', {
            count: slot.remainingStock
          }))),
          isDisabledRadio: slot.remainingStock === 0 || ((_service$attendees$fi = service.attendees.find(function (_ref5) {
            var id = _ref5.id;
            return id === service.childId;
          })) === null || _service$attendees$fi === void 0 ? void 0 : (_service$attendees$fi2 = _service$attendees$fi.schedules) === null || _service$attendees$fi2 === void 0 ? void 0 : (_service$attendees$fi3 = _service$attendees$fi2[0]) === null || _service$attendees$fi3 === void 0 ? void 0 : _service$attendees$fi3.isPartiallyPaid)
        };
      }),
      radioHasBorder: false,
      itemsCentered: false
    }), __jsx("div", {
      className: "flex w-full items-center justify-center pt-40"
    }, __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_29__[/* Button */ "a"], {
      onClick: function onClick() {
        return handleSubmit(formik.values);
      },
      isDisabled: !formik.values.selectedSlotProductId || formik.values.selectedSlotProductId === (initiallySelectedSlot === null || initiallySelectedSlot === void 0 ? void 0 : initiallySelectedSlot.id),
      "data-testid": "PopInReservationBlockMorningAfternoonExclusive-add",
      isLoading: isLoading,
      size: "medium",
      trackingData: {}
    }, Object(_i18n__WEBPACK_IMPORTED_MODULE_24__[/* t */ "h"])('booking.common.add'), " +", orderedSlots === null || orderedSlots === void 0 ? void 0 : (_orderedSlots$find2 = orderedSlots.find(function (slot) {
      return slot.id === formik.values.selectedSlotProductId;
    })) === null || _orderedSlots$find2 === void 0 ? void 0 : (_orderedSlots$find2$a = _orderedSlots$find2.attendees[0]) === null || _orderedSlots$find2$a === void 0 ? void 0 : (_orderedSlots$find2$a2 = _orderedSlots$find2$a.price) === null || _orderedSlots$find2$a2 === void 0 ? void 0 : _orderedSlots$find2$a2.formattedValue)));
  }))));
};

/***/ })

}]);